import { render, staticRenderFns } from "./ConfigSchedulesList.vue?vue&type=template&id=94dd4ea2&scoped=true&"
import script from "./ConfigSchedulesList.vue?vue&type=script&lang=js&"
export * from "./ConfigSchedulesList.vue?vue&type=script&lang=js&"
import style0 from "./ConfigSchedulesList.vue?vue&type=style&index=0&id=94dd4ea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94dd4ea2",
  null
  
)

export default component.exports